import React                      from 'react' 
import Icon                       from '../../../../core-components/IconsSelector';
import * as S                     from './Benefits.styles';
import { 
  useDispatch, 
  useSelector 
}                                 from 'react-redux';
import { CAB_TYPE_DETAIL_MODAL }  from '../../../../../shared/pages/SearchPage/redux/action-types';
import { tripTypeSelector } from '../../../../../shared/common/redux/selector';
import { pushCtaOmniEvents } from '../../../../../shared/config/omni';
import { CTA_TYPE } from '../../../../../shared/utils/omni-utils';
import { AIRPORT_CABS, CABS_LISTING_ROUTE, LOCAL_RENTAL, MOB_CABS_LISTING, ONE_WAY, ROUND_TRIP, SEARCH_PAGE, WHY_BOOK_KNOW_MORE_CLICK } from '../../../../../shared/utils/util-constants';

const Benefits = ({ t = '', list = [] }) => {
  const dispatch = useDispatch()
  const tripType = useSelector(tripTypeSelector)

  const getPersuationType = () : string => {
    let persuationType : string = ''

    switch (tripType?.name) {

      case ONE_WAY    :
        persuationType = `OW_${WHY_BOOK_KNOW_MORE_CLICK}`
        break

      case ROUND_TRIP : 
        persuationType = `RT_${WHY_BOOK_KNOW_MORE_CLICK}`
        break

      case LOCAL_RENTAL :
        persuationType = `Rental_${WHY_BOOK_KNOW_MORE_CLICK}`
        break

      case AIRPORT_CABS :
        persuationType = `AT_${WHY_BOOK_KNOW_MORE_CLICK}`
    }

    return persuationType
  }
  const showKnowMore = () => {
    const persuationType : string = getPersuationType()
    pushCtaOmniEvents(`${MOB_CABS_LISTING}_${persuationType}`, CTA_TYPE.HYPER_LINK, SEARCH_PAGE, CABS_LISTING_ROUTE)
    dispatch({
      type                    : CAB_TYPE_DETAIL_MODAL,
      showCabTypeDetailsModal : true
    })
  }

  if (!t && !list?.length) return null;
  return (
    <>
      <S.BenefitsWrapper>
        <S.Title>{t}</S.Title>
        <S.Outerwrapper>
          {list.map((item) => (
            <S.BenefitsLi key={item}>
              <Icon name="BenefitsIcon" styleProps={{ width: '2.5rem' }} />
              <S.BenefitsTxt>{item}</S.BenefitsTxt>
            </S.BenefitsLi>
          )) || null}
        </S.Outerwrapper>
        <S.FooterTitle onClick={() => showKnowMore()}>
          know more
        </S.FooterTitle>
      </S.BenefitsWrapper>
    </>

  );
}

export default Benefits;